module.exports = __webpack_public_path__ + "media/bootstrap-icons/file-arrow-up-4c249e8b.svg";